var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 17.1172V12.7422C1.87696 12.0797 2.14098 11.445 2.6094 10.9766C3.07781 10.5082 3.71256 10.2441 4.375 10.2422H15.625C16.2874 10.2441 16.9222 10.5082 17.3906 10.9766C17.859 11.445 18.123 12.0797 18.125 12.7422V17.1172M15 10.2422H3.75V6.17969C3.75124 5.76567 3.91625 5.36896 4.20901 5.0762C4.50177 4.78344 4.89848 4.61842 5.3125 4.61719H14.6875C15.1015 4.61842 15.4982 4.78344 15.791 5.0762C16.0837 5.36896 16.2488 5.76567 16.25 6.17969V10.2422H15Z",
    stroke: "#BFBFBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 17.1172V16.8047C1.87572 16.5563 1.97473 16.3182 2.15038 16.1426C2.32604 15.9669 2.56408 15.8679 2.8125 15.8672H17.1875C17.4359 15.8679 17.674 15.9669 17.8496 16.1426C18.0253 16.3182 18.1243 16.5563 18.125 16.8047V17.1172M4.375 10.2422V9.61719C4.37593 9.28595 4.50792 8.96855 4.74214 8.73433C4.97636 8.50011 5.29376 8.36812 5.625 8.36719H8.75C9.08124 8.36812 9.39864 8.50011 9.63286 8.73433C9.86708 8.96855 9.99907 9.28595 10 9.61719M10 9.61719V10.2422M10 9.61719C10.0009 9.28595 10.1329 8.96855 10.3671 8.73433C10.6014 8.50011 10.9188 8.36812 11.25 8.36719H14.375C14.7062 8.36812 15.0236 8.50011 15.2579 8.73433C15.4921 8.96855 15.6241 9.28595 15.625 9.61719V10.2422",
    stroke: "#BFBFBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.e05bd669df847d4c25b0b87abde15015.svg";
export { ForwardRef as ReactComponent };